const API_VERSION = "2024-07";
const STOREFRONT_API_KEY = "f1b431090dc81fca58b846be8a75d56e";
const STOREFRONT_API_URL = `https://${Shopify.shop}/api/${API_VERSION}/graphql.json`;

const gong = {

    /**
     * Initialize the Gong customization
     */
    init: () => {
        document.addEventListener('gong:cart:open', function (e) {
            cartIsOpen(e).then();
        });

        lazyLoadVideos();

        newsletterCustomFunction()

        openAccordion();

        autoLoadMoreOnSearchResults();

        if (window.location.href.indexOf('/products/') > -1){
            document.addEventListener('DOMContentLoaded', () => {
                initStickAddToCart();

                // Écoute les changements de variante
                document.addEventListener('onvariantchange:finished', () => {
                    initStickAddToCart();
                });
            });
        }else{

        }
    }
}

// --------------------- CART ---------------------
async function cartIsOpen(e) {

    const cart = await fetch(`${window.Shopify.routes.root}cart.js`)
        .then((res) => res.json());

    if (typeof cart !== 'object' || cart === null) {
        return;
    }
    if (cart.items.length === 0) {
        return;
    }

    let last_cart_version_with_sections = null;

    let items = cart.items;
    let all_variants_data = [];
    let line = 0;

    let props_changed = [];

    for (const item of items) {
        line++;

        //if product is a pack (properties _is_pack), continue
        if (item.properties !== null && item.properties['_is_pack'] !== undefined) {
            continue;
        }

        if (all_variants_data[item.variant_id] === undefined) {
            all_variants_data[item.variant_id] = await getVariant(item.variant_id);
        }

        let variant_data = all_variants_data[item.variant_id];
        let quantityAvailable = variant_data.node.quantityAvailable;

        let actions = {
            "remove": 0,
            "add_props": 0,
            "remove_props": 0,
            "already_preorder": 0,
            "already_available": 0
        };

        //do the test if available / preorder / not available on each quantity item
        for (let i = 0; i < item.quantity; i++) {

            //Test if item is available
            if (quantityAvailable > 0) {

                if (item.properties['_pre-order'] !== undefined && item.properties['_pre-order'] === '1') {
                    console.log("Need to remove props for line item", item)
                    actions.remove_props++;
                } else {
                    actions.already_available++;
                }

            } else {

                //Test if item is preorder
                if (variant_data.node.preorder?.value === 'true') {

                    //test if the quantity upper than the stock threshold, if yes -> preorder, if not -> remove from cart
                    if (quantityAvailable > variant_data.node.stock_threshold?.value) {

                        //test if properties are already added
                        let temp_need_to_add_props = false;
                        let properties = item.properties;

                        if (properties === null) {
                            properties = {};
                        }
                        if (properties['_pre-order'] === undefined || properties['_pre-order'] === '0') {
                            temp_need_to_add_props = true;
                        }
                        if (properties['_pre-order-date'] === undefined || properties['_pre-order-date'] === '') {
                            temp_need_to_add_props = true;
                        }
                        if (properties['_container'] === undefined || properties['_container'] === '') {
                            temp_need_to_add_props = true;
                        }
                        if ((properties['Précommande'] === undefined || properties['Précommande'] === '') && (properties['Preorder'] === undefined || properties['Preorder'] === '')) {
                            temp_need_to_add_props = true;
                        }
                        // if (properties['Preorder'] === undefined || properties['Preorder'] === '') {
                        //     temp_need_to_add_props = true;
                        // }

                        if (temp_need_to_add_props === true) {
                            actions.add_props++;
                        } else {
                            actions.already_preorder++;
                        }

                    } else {
                        actions.remove++;
                    }
                } else {
                    actions.remove++;
                }
            }

            //end of the process, remove one quantity to the quantity available
            quantityAvailable--;
        }

        //set the quantity available to the all_variants_data
        all_variants_data[item.variant_id].node.quantityAvailable = quantityAvailable;

        //Apply the actions for the cart line item
        let new_quantity = item.quantity;
        if (actions.remove > 0) {
            console.log("Need to remove line item quantity")
            new_quantity = item.quantity - actions.remove;
            let result = await removeQuantityFromLineInCart(line, new_quantity);
            if (result === false) {
                console.log("error removing line item in preorder cart for line", line)
            } else {
                last_cart_version_with_sections = result;
            }
        }

        //if the quantity is 0, the line is removed from the cart, so we need to minus the current line, and the process if finish for this line
        if (new_quantity === 0) {
            line--;
            continue;
        }

        if (props_changed[item.variant_id] === undefined) {
            props_changed[item.variant_id] = {
                "need_change": false,
                "in_preorder": 0,
                "need_props": 0,
                "available": 0,
                "need_remove": 0
            };
        }

        if (actions.add_props > 0 || actions.remove_props > 0) {
            props_changed[item.variant_id].need_change = true;
        }
        props_changed[item.variant_id].in_preorder = props_changed[item.variant_id].in_preorder + actions.already_preorder + actions.add_props;
        props_changed[item.variant_id].available = props_changed[item.variant_id].available + actions.already_available + actions.remove_props;
        props_changed[item.variant_id].need_props = props_changed[item.variant_id].need_props + actions.add_props;
        props_changed[item.variant_id].need_remove = props_changed[item.variant_id].need_remove + actions.remove;
    }

    //Apply the actions for the variant that needed
    for (const variant_id in props_changed) {
        let variant_change = props_changed[variant_id];

        if (variant_change.need_change === true) {
            if (variant_change.need_props > 0) {

                console.log("Need to add props for variant ID : ", variant_id)
                let variant_data = all_variants_data[variant_id];
                let properties = {
                    "_pre-order": variant_data.node.preorder?.value === 'true' ? '1' : '0',
                    "_pre-order-date": variant_data.node.preorderDate?.value,
                    "_container": variant_data.node.shippingContainer?.value
                }

                if (`${window.Shopify.locale}` === "fr"){
                    properties.Précommande = "Oui";
                }else{
                    properties.Preorder = "Yes";
                }

                let result = await addPropertiesToVariantIDInCart(variant_id, properties);
                if (result === false) {
                    console.log("error adding props in preorder cart for variant ID", variant_id)
                } else {
                    last_cart_version_with_sections = result;
                }

            } else {
                if (variant_change.in_preorder > 0) {
                    console.log("Some variant are preorder, so we can't remove the props for variant ID", variant_id)
                } else {
                    console.log("Need to remove props for variant ID : ", variant_id)
                    let properties = {
                        "_no-props": "1"
                    }
                    let result = await addPropertiesToVariantIDInCart(variant_id, properties);
                    if (result === false) {
                        console.log("error removing props in preorder cart for variant ID", variant_id)
                    } else {
                        last_cart_version_with_sections = result;
                    }
                }
            }
        }
    }

    if (last_cart_version_with_sections !== null) {
        console.log("Need to reload the cart");
        await updateCart(last_cart_version_with_sections)
    }
}

//Function taken from the common js, here e (the param) is a JSON cart version with sections (cart-drawer & cart-icon-bubble)
async function updateCart(e) {
    document.body.classList.add("cart-is-updating");
    getSectionsToRender("drawer-cart").forEach((t) => {
        document.querySelector(t.selector).innerHTML = getSectionInnerHTML(e.sections[t.id], t.selector);
    });
    setTimeout(() => {
        let e = document.querySelector("variant-radios");
        e?.renderProductInfo();
    }, 800);
    document.body.classList.remove("cart-is-updating");
    window.lozadObserver.observe();
}

function getSectionsToRender(sectionId) {
    const isCartPage = document.body.classList.contains("template-cart");

    return isCartPage
        ? [
            {id: sectionId, selector: "#main-cart"},
            {id: "cart-icon-bubble", selector: "#cart-icon-bubble"},
        ]
        : [
            {id: sectionId, selector: "w3-drawer-cart .drawer__main"},
            {id: sectionId, selector: "w3-drawer-cart .drawer__main"},
            {id: sectionId, selector: "w3-drawer-cart .drawer__footer"},
            {id: "cart-icon-bubble", selector: "#cart-icon-bubble"},
        ];
}

function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
}

async function removeQuantityFromLineInCart(lineKey, quantity) {
    try {
        const response = await fetch(`${window.routes.cart_change_url}.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                "line": lineKey,
                "quantity": quantity,
                "sections": 'drawer-cart,cart-icon-bubble'
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error removing item from cart:', error);
        return false;
    }
}

async function addPropertiesToVariantIDInCart(id, properties) {
    try {
        const response = await fetch(`${window.routes.cart_change_url}.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                "id": id,
                "properties": properties,
                "sections": 'drawer-cart,cart-icon-bubble',
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error adding properties to variant in cart:', error);
        return false;
    }
}



// --------------------- NEWSLETTER ---------------------
function newsletterCustomFunction(){
    //Newsletter anchor handle after submission
    document.addEventListener('DOMContentLoaded', function (e) {
        listenToNewsletterTagsChange();

        if (window.location.href.indexOf('/challenge') > -1 && window.location.href.indexOf('return_path=%2F#contact_form') > -1) {

            // Désactiver la restauration automatique du scroll
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }

            // Supprimez temporairement l'ancre de l'URL
            var urlWithoutHash = window.location.href.split('#')[0];
            history.replaceState(null, null, urlWithoutHash);

            // Effectuez le défilement
            var mainContent = document.getElementById('MainContent');
            if (mainContent) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Défilement fluide
                });
            }

            // Remettez l'ancre après un léger délai pour éviter le saut
            setTimeout(function () {
                history.replaceState(null, null, urlWithoutHash + '#contact_form');
            }, 100);
        }

        //?customer_posted=true#contact_form
        if (window.location.href.indexOf('?customer_posted=true#contact_form') > -1) {
            // Supprimez temporairement l'ancre de l'URL
            let urlWithoutHash = window.location.href.split('#')[0];
            history.replaceState(null, null, urlWithoutHash);

            // Désactiver la restauration automatique du scroll
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }

            let newsletter = document.getElementById('newsletter');
            let rect = newsletter.getBoundingClientRect();
            let scrollToPosition = window.pageYOffset + rect.top; // Position relative à la page


            window.scrollTo({
                top: scrollToPosition,
                behavior: 'instant'
            });

            setTimeout(function () {
                document.location.hash = "#contact_form";
            }, 100);
        }
    })
}

function listenToNewsletterTagsChange() {
    //listen click on checkbox with class js-newsletter-sport-interest and change the value of the hidden input with id newsletter-form-tag

    let checkboxes = document.querySelectorAll('.js-newsletter-sport-interest');
    for (let i = 0; i < checkboxes.length; i++) {
        checkboxes[i].addEventListener('change', (event) => {
            let checkbox = event.target;
            let value = checkbox.value;
            let checked = checkbox.checked;
            if (checked) {
                document.getElementById('newsletter-form-tag').value = document.getElementById('newsletter-form-tag').value + ',' + value;
            } else {
                document.getElementById('newsletter-form-tag').value = document.getElementById('newsletter-form-tag').value.replace(value, '');
            }
        });
    }
}



// --------------------- LAZY LOADING ---------------------
function lazyLoadVideos() {
    document.addEventListener("DOMContentLoaded", function () {
        let lazyVideos = [...document.querySelectorAll("video.lazy")]

        if ("IntersectionObserver" in window) {
            let lazyVideoObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (video) {
                    if (video.isIntersecting) {
                        for (let source in video.target.children) {
                            let videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }

                        video.target.load();
                        video.target.classList.remove("lazy");
                        video.target.play();
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });

            lazyVideos.forEach(function (lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });
        }
    });

    window.addEventListener("load",function(){
        //Launch HERO SLIDER VIDEO AUTOPLAY
        document.querySelectorAll(".home-slider-card-video").forEach(function (video) {
            video.play();
        });
    });
}



// --------------------- ACCORDION FAQ COLLECTION ---------------------
function openAccordion() {
    document.addEventListener("DOMContentLoaded", () => {
        const faqMenu = document.querySelectorAll(".collection-accordion__menu a");

        faqMenu.forEach((link) => {
            link.addEventListener("click", (e) => {
                const id = e.target.getAttribute("data-id");
                document.querySelector("#" + id + " .collection-accordion__tab").setAttribute("open", "true");
            })
        });

        // Vérifie si l'URL contient le hash "FAQ" et ouvre la section correspondante
        if (window.location.hash && window.location.hash.includes("FAQ")) {
            const hashId = window.location.hash.substring(1); // Supprime le # pour obtenir l'ID

            const targetTab = document.querySelector("#" + hashId + " .collection-accordion__tab");

            if (targetTab) {
                // Supprimez temporairement l'ancre de l'URL
                let urlWithoutHash = window.location.href.split('#')[0];
                history.replaceState(null, null, urlWithoutHash);

                // Désactiver la restauration automatique du scroll
                if ('scrollRestoration' in history) {
                    history.scrollRestoration = 'manual';
                }

                setTimeout(function () {
                    let rect = targetTab.getBoundingClientRect();
                    let scrollToPosition = window.scrollY + rect.top; // Position relative à la page

                    window.scrollTo({
                        top: scrollToPosition,
                        behavior: 'instant'
                    });

                    targetTab.setAttribute("open", "true");

                    setTimeout(function () {
                        document.location.hash = "#" + hashId;
                    }, 100);
                },100)
            }
        }
    });
}



// --------------------- AUTO LOAD MORE ON SEARCH RESULTS ---------------------
function autoLoadMoreOnSearchResults() {
    if (window.location.href.indexOf('/search') > -1){
        document.addEventListener("DOMContentLoaded", function () {
            // Sélectionne le bouton de chargement
            const loadMoreBtn = document.querySelector('.js-load-more-btn');

            if (loadMoreBtn) {
                // Initialise un observateur pour surveiller le bouton
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        // Vérifie si le bouton est visible
                        if (entry.isIntersecting) {
                            // Simule un clic sur le bouton lorsqu'il est visible
                            loadMoreBtn.click();
                        }
                    });
                });

                // Commence à observer le bouton
                observer.observe(loadMoreBtn);
            }
        });
    }
}



// --------------------- STICKY ADD TO CART ---------------------
let currentObserver = null; // Variable pour stocker l'observateur actuel

function initStickAddToCart() {
    const mainForm = document.querySelector(".product-buybox .product-form"); // Formulaire principal
    const addToCartButton = mainForm?.querySelector("button[type='submit']");
    const stickyFooter = document.querySelector(".container-sticky-add-to-cart");

    const stickyButton = document.querySelector("#product-add-to-cart-sticky");

    // Déconnecter l'ancien observateur s'il existe
    if (currentObserver) {
        currentObserver.disconnect();
    }

    if (mainForm && addToCartButton) {
        // Créer un nouvel observateur pour détecter si le bouton principal est visible
        currentObserver = new IntersectionObserver((entries) => {
            const isVisible = entries.some(entry => entry.isIntersecting);

            if (!isVisible && !isAboveElement(addToCartButton)) {
                stickyFooter.classList.add("show");
            } else {
                stickyFooter.classList.remove("show");
            }
        }, { threshold: 0.1 });

        currentObserver.observe(addToCartButton); // Observer le bouton principal
    }

    // Éviter de doubler les événements pour stickyButton
    stickyButton?.removeEventListener("click", handleStickyButtonClick);
    stickyButton?.addEventListener("click", handleStickyButtonClick);
}
function handleStickyButtonClick() {
    const stickyButton = document.querySelector("#product-add-to-cart-sticky");
    stickyButton?.classList.add("button-loading");

    const addToCartButton = document.querySelector(".product-buybox .product-form button[type='submit']");
    addToCartButton?.click();
}
function isAboveElement(element) {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0; // Si le haut de l'élément est visible ou au-dessus du viewport
}



// --------------------- HELPERS ---------------------
//this function is also used in the fastbundle script
async function getVariant(variantId) {
    return await requestStorefrontAPI({
        query: `{
            node(id: "${gid('ProductVariant', variantId)}") {
                ...on ProductVariant {
                    id
                    title,
                    quantityAvailable,
                    preorder: metafield(namespace: "custom", key: "preorder") {
                        value
                    }
                    preorderDate: metafield(namespace: "custom", key: "preorder_date") {
                        value
                    }
                    shippingContainer: metafield(namespace: "custom", key: "shipping_container") {
                        value
                    }
                    stock_threshold: metafield(namespace: "custom", key: "preorder_stock") {
                        value
                    }
                }
            }
        }`
    }).then(response => response.data);
}

//this function is also used in the fastbundle script
function gid(ressource, id) {
    return `gid://shopify/${ressource}/${id}`;
}

//this function is also used in the fastbundle script
function requestStorefrontAPI(query) {
    return fetch(STOREFRONT_API_URL, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Shopify-Storefront-Access-Token": STOREFRONT_API_KEY
        },
        body: JSON.stringify(query)
    }).then(response => response.json());
}